import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMMasterResource from 'resources/SMMasterResource';
import SMRoomResource from 'resources/SMRoomResource';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMPaymentSelectHelper from 'components/helpers/SMPaymentSelectHelper';
import SMCardHelper from 'components/helpers/SMCardHelper';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import { companyFragment } from 'fragments';

class SMReservationRequestView extends React.Component {

  constructor(props) {
    super(props);

    this.requestParams = this.props.requestParams;

    this.capacityDidChange = this.capacityDidChange.bind(this);

    if (this.props.inquiry) {
      this.requestParams.event_type = this.props.inquiry.event_type;
      this.requestParams.use_type = this.props.inquiry.use_type;
      this.requestParams.capacity = this.props.inquiry.capacity;
    }

    this.state = {
      reservation: props.reservation,
      capacities: [],
      cardErrorMessage: "",
      witchCardError: null,
      couponErrorMessage: "",
      pointErrorMessage: "",
      isDisabled: false,
      isAppliedCoupon: false,
      isAppliedPoint: false,
      selectedDiscount: 0,
      activeCards: [],
      couponCode: "",
      applyPointAmount: "",
      paymentSelect: null,
      errors: {},
      isCardOnly: (this.requestParams.use_type != SMConst.ReservationUseType.Corporate),
      openNewCard: false,
      selectedCard: null,
      companies: [],
      selectedCompany: null,
      businessUseDescription: "",
    };
  }

  isStayPlan() {
    if (!this.props.reservation.plan) {
      return (this.props.reservation.room.rent_type && this.props.reservation.room.rent_type == SMConst.RentType.Stay);
    } else {
      return (this.props.reservation.plan.rent_type && this.props.reservation.plan.rent_type == SMConst.RentType.Stay);
    }
  }

  isPerPersonPlan() {
    if (!this.props.reservation.plan) {
      return this.props.reservation.room.price_calc_type == SMConst.PriceCalcType.PerPerson;
    } else {
      return this.props.reservation.plan.price_calc_type == SMConst.PriceCalcType.PerPerson;
    }
  }

  componentDidMount() {
    SMMasterResource.getCapacities((capacities, error, xhr)=>{
      this.setState({capacities: capacities});
    });

    if (!this.isStayPlan() && !this.isPerPersonPlan() && !this.requestParams.capacity) {
      this.requestParams.capacity = 1;
    }

    // GA Ecommerce
    const room = this.props.room;
    this.subscribeCapacitySelectEvent();

    ga('ec:addProduct', {
      id: room.id,
      name: room.name,
      category: `${room.space.country_alpha2}/${room.space.state}/${room.space.space_type}`,
      brand: room.owner.id
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ reservation: nextProps.reservation });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      $(this.refs.form).startLoading();
      SMUserResource.getPayments(this.props.currentUser.id, (activeCards, error, xhr)=>{
        if (!error) {
          if (activeCards && activeCards.length > 0) {
            this.setState({activeCards: activeCards});
            this._setPayment(SMConst.PaymentSelect.Card, activeCards[0].id);
          }
          $(this.refs.form).stopLoading();

        } else {
          $(this.refs.form).stopLoading();
          switch (xhr.status) {
            case 400:
              const errorsArray = xhr.responseJSON.errors;
              let errors = {};
              errorsArray.forEach((error)=>{
                errors[error.field] = error.message;
              });
              this.setState({errors: errors});
              break;
            case 402:
              break;
          }
        }
      });
      this.requestCompanies();

      SMTrackHelper.pageView(location.pathname + "/request");
      mixpanel.track("Reservation New", {"Platform" : "Web",});
      this.subscribeCapacitySelectEvent();

      // GA Ecommerce
      ga('ec:setAction', 'add');
      ga('send', 'event', 'ec', 'action', 'add to cart');
    }
  }

  async requestCompanies() {
    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies {
            results{
              ... on Company {
                ${companyFragment}
              }
            }
          }
        }
      }
    `;
    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  subscribeCapacitySelectEvent() {
    $(".js-reserve__spinner_capacity").each((index, el) =>{
      const $el = $(el);
      let max = this.props.room.capacity;
      let min = 1;

      $el.spinner({
        max: max,
        min: min,

        spin: (event, ui)=>{
          $el.spinner("value", ui.value);
          this.requestParams.capacity = ui.value;
          return false;
        }
      });
    });
  }

  dismiss(e) {
    this.setState({ isAppliedCoupon: false });
    this.requestParams.coupon_code = '';
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.requestViewDidClose === 'function'){
        this.props.delegate.requestViewDidClose();
      }
    }

    // GA Ecommerce
    ga('ec:setAction', 'remove');
    ga('send', 'event', 'ec', 'action', 'remove from cart');
  }

  renderRequestError(name) {
    const message = this.state.errors[name];
    if (message) {
      return(
        <p className="reserve-situation__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }

  requestReservation() {
    this.setState({display: SMConst.Display.Loading});

    // GA Ecommerce
    ga('ec:setAction', 'checkout', {'step': 1});
    ga('send', 'event', 'ec', 'action', 'checkout validation');

    const responseHandler = (reservation, error, xhr)=>{
      if (error) {
        this.setState({
          isDisabled: false,
          display: SMConst.Display.Visible,
        });

        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402:
            this.setState({
              cardErrorMessage: JSON.parse(xhr.responseText).message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
            break;
        }
      } else {
        // Google Analytics 拡張eコマース
        this.sendGaEcommerce(reservation);

        const room = reservation.room;
        SMAppHelper.redirectTo(Routes.sent_space_room_reservation_path(room.space.username, room.uid, reservation.uid, {search_session_id: this.props.searchSessionId}));
      }
    };

    if (this.props.inquiry) {
      SMUserResource.updateReservation(
        this.props.currentUser.username,
        this.props.inquiry.uid,
        this.requestParams,
        {},
        responseHandler
      );
    } else {
      SMRoomResource.requestReservation(this.props.room.id, this.requestParams, responseHandler);
    }
  }

  formDidSubmit(e) {
    e.preventDefault();
    this.setState({
      cardErrorMessage: "",
      witchCardError: null,
      isDisabled: true,
    });
    this.requestReservation();
  }

  sendGaEcommerce(reservation) {
    const room = reservation.room;
    let couponCode = "";
    if(reservation.billing.coupon != null){
     couponCode = reservation.billing.coupon.code;
    }

    ga('set', 'currencyCode', reservation.billing.currency);

    ga('ec:addProduct', {
      'id': room.id,
      'name': room.name,
      'category': `${room.space.country_alpha2}/${room.space.state}/${room.space.space_type}`,
      'brand': room.owner.id,
      'quantity': 1,
    });

    ga('ec:setAction', 'purchase', {
      'id': reservation.id,
      'revenue': reservation.billing.total_amount_except_tax,
      'tax': reservation.billing.guest_sales_tax,
      'shipping': reservation.billing.guest_fee_amount,
      'coupon': couponCode,
      'currencyCode': reservation.billing.currency,
    });

    ga('send', 'event', 'ec', 'action', 'purchase');
  }

  discountDidChangeValue(e) {
    this.setState({
      selectedDiscount: parseInt(e.currentTarget.value),
    });
  }

  couponApplyButtonDidClick(e) {
    this.setState({ couponCode: this.refs.inputCouponCode.value });
    this.requestParams.coupon_code = this.refs.inputCouponCode.value;
    SMRoomResource.validateReservation(this.props.room.id, this.requestParams, (reservation, error, xhr)=>{
      if (xhr.status != 200) {
        this.requestParams.coupon_code = '';
        this.setState({ couponErrorMessage: xhr.responseJSON.message });
      } else {
        this.setState({ couponErrorMessage: '', isAppliedCoupon: true, reservation: reservation });
      }
    });
  }

  couponRevokeButtonDidClick(e) {
    // クーポン情報戻す
    this.requestParams.coupon_code = '';
    this.setState({ isAppliedCoupon: false });
    this.billingRecalc();
  }

  couponCodeDidChange(e) {
    this.setState({ couponCode: e.currentTarget.value });
  }

  pointApplyButtonDidClick(e) {
    this.setState({ applyPointAmount: this.refs.inputApplyPointAmount.value });
    this.requestParams.apply_point_amount = this.refs.inputApplyPointAmount.value;
    SMRoomResource.validateReservation(this.props.room.id, this.requestParams, (reservation, error, xhr)=>{
      if (xhr.status != 200) {
        this.requestParams.apply_point_amount = '';
        this.setState({ pointErrorMessage: xhr.responseJSON.message });
      } else {
        this.setState({ pointErrorMessage: '', isAppliedPoint: true, reservation: reservation });
      }
    });
  }

  applyPointDidChange(e) {
    this.setState({ applyPointAmount: e.currentTarget.value });
  }

  pointRevokeButtonDidClick(e) {
    this.requestParams.apply_point_amount = '';
    this.setState({ isAppliedPoint: false });
    this.billingRecalc();
  }

  eventTypeDidChange(e) {
    this.requestParams.event_type = e.currentTarget.value;
  }

  useTypeDidChange(e) {
    this.requestParams.use_type = e.currentTarget.value;
    this.setState({
      isCardOnly: (this.requestParams.use_type != SMConst.ReservationUseType.Corporate)
    });
  }

  capacityDidChange(e) {
    this.requestParams.capacity = e.currentTarget.value;
  }

  contentDidChange(e) {
    this.requestParams.content = e.currentTarget.value;
  }

  businessUseDescriptionDidChange(e) {
    const val = e.currentTarget.value;
    this.requestParams.business_use_description = val;
    this.setState({
      businessUseDescription: val
    });
  }

  renderEventTypeOptions(room) {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    room.event_types.forEach((eventType, i)=>{
      rows.push(
        <option key={i} value={eventType.name}>{eventType.name_text}</option>
      );
    });
    return rows;
  }

  renderUseTypeOptions(room) {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    const useTypesData = [
      {value:SMConst.ReservationUseType.Indivisual, label: I18n.t("service.label_000048")},
      {value:SMConst.ReservationUseType.Corporate, label: I18n.t("service.label_000049")}
    ];
    useTypesData.forEach((useType, i)=>{
      rows.push(
        <option key={i} value={useType.value}>{useType.label}</option>
      );
    });
    return rows;
  }

  renderCapacitySelect() {
    return(
      <input onChange={(e) => this.capacityDidChange(e)} className="js-reserve__spinner_capacity" name="number" defaultValue={this.requestParams.capacity} />
    );
  }

  renderCardError() {
    if (this.state.cardErrorMessage && this.state.witchCardError == this.state.paymentSelect) {
      return(
        <p className="popup-form__required request-payment__required"><i className="fa fa-exclamation-circle"></i>{this.state.cardErrorMessage}</p>
      );
    }
    return null;
  }

  renderDiscountForm() {
    if (this.state.selectedDiscount == 0) {
      return (
        <div className="popup-form__point">
          <p className="popup-form__text">ポイントをご利用の方はポイント数を入力してください。</p>
          {this.renderPointForm()}
        </div>
      );
    } else {
      return (
        <div className="popup-form__coupon">
          <p className="popup-form__text">クーポンをご利用の方はクーポンコードを入力してください。</p>
          {this.renderCouponForm()}
        </div>
      );
    }
  }

  renderPointForm() {
    const applyButtonClassName = `button-blue w70 pt9 pb9 ${(this.state.applyPointAmount) ? '' : 'button-disabled'}`;

    if (this.state.isAppliedPoint) {
      return (
        <div>
          <p className="pt9 pb9">
            {this.state.applyPointAmount}ポイント
            <a onClick={this.pointRevokeButtonDidClick.bind(this)} className="a__underline ml10"><i className="fa fa-times mr3" />削除</a>
          </p>
          <p className="popup-form__completed"><i className="fa fa-check-circle" />ポイントが適用されました。</p>
        </div>
      );
    } else {
      return(
        <div>
          <input type="text" value={this.state.applyPointAmount} className="w200 mr10" placeholder="半角数字で入力" ref='inputApplyPointAmount' onChange={this.applyPointDidChange.bind(this)} />
          <input type="button" className={applyButtonClassName} defaultValue="適用" onClick={this.pointApplyButtonDidClick.bind(this)} />
          <p className="popup-form__point-title">所持ポイント：{this.props.currentUser.point_balance.available_amount}<span className="popup-form__point-now">{}</span></p>
          {this.renderPointError()}
        </div>
      );
    }
  }

  renderPointError() {
    if (this.state.pointErrorMessage) {
      return <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{this.state.pointErrorMessage}</p>;
    }
    return null;
  }

  renderCouponForm() {
    const applyButtonClassName = `button-blue w70 pt9 pb9 ${(this.state.couponCode) ? '' : 'button-disabled'}`;

    if (this.state.isAppliedCoupon) {
      return(
        <div>
          <p className="pt9 pb9">{this.state.couponCode}<a onClick={this.couponRevokeButtonDidClick.bind(this)} className="a__underline ml10"><i className="fa fa-times mr3"></i>削除</a></p>
          <p className="popup-form__completed"><i className="fa fa-check-circle"></i>クーポンが適用されました。</p>
        </div>
      );
    } else {
      return(
        <div>
          <input type="text" value={this.state.couponCode} ref='inputCouponCode' className="w200 mr10" placeholder="クーポンコードを入力" onChange={this.couponCodeDidChange.bind(this)} />
          <input type="button" className={applyButtonClassName} value="適用" onClick={this.couponApplyButtonDidClick.bind(this)} disabled={!this.state.couponCode} />
          {this.renderCouponError()}
        </div>
      );
    }
  }

  renderCouponError() {
    if (this.state.couponErrorMessage) {
      return <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{this.state.couponErrorMessage}</p>;
    }
    return null;
  }

  requestPayments() {
    SMUserResource.getPayments(this.props.currentUser.id, (activeCards, error, xhr)=>{
      if (!error) {
        this.setState({
          activeCards: activeCards,
          openNewCard: false
        });
        this.props.reservation.billing.payment_method == SMConst.PaymentMethod.Bank ? this._setPayment(SMConst.PaymentSelect.Bank, null) : this._setPayment(SMConst.PaymentSelect.Card, activeCards[0].id);
        $(this.refs.form).stopLoading();
      } else {
        $(this.refs.form).stopLoading();
        switch (xhr.status) {
          case 400:
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 402:
            break;
        }
      }
    });
  }

  renderActiveCards() {
    const cards = this.state.activeCards;
    const rows = [];

    if (cards) {
      cards.forEach((card, index) => {
        let cardType = card.type.toLowerCase();
        if (cardType == "american express") {
          cardType = "amex";
        }
        const className = sprintf("fa fa-cc-%s fa-lg payment-card__%s", cardType, cardType);

        rows.push(
          <p key={card.id} className="request-payment__cards-registered">
            <input type="radio"
              onClick={this.paymentDidSelect.bind(this)}
              value={SMConst.PaymentSelect.Card}
              checked={SMPaymentSelectHelper.isCard(this.state.paymentSelect) && this.state.selectedCard == card.id}
              id={"request-radio__01" + card.id}
              name="request-radio"
              data-paymentId={card.id}  />
            <label htmlFor={"request-radio__01" + card.id} className="service-radio">
              <span className="request-payment__name">
                <i className={className}></i> **** **** **** {card.last4} 名義人：{card.name} 有効期限：{card.exp_month}/{card.exp_year}
              </span>
            </label>
          </p>
        );
      });
    }
    return(
      <div>
        {rows}
      </div>
    );
  }

  didClickAddNewCard(e) {
    e.preventDefault();

    const helper = new SMCardHelper();
    $(this.refs.form).startLoading();
    helper.generateToken({
      success: (response)=>{
        helper.removeCardItemBeforeSubmit();
        SMUserResource.postPayment(this.props.currentUser.username, response.id, (data, error, xhr)=>{
          if(!error) {
            this.setState({
              cardErrorMessage: ""
            });
            this.requestPayments();
          } else {
            $(this.refs.form).stopLoading();
            this.setState({
              cardErrorMessage: JSON.parse(xhr.responseText).message,
              witchCardError: this.state.paymentSelect,
              isDisabled: false,
            });
          }
        });
      },
      error: (response)=>{
        $(this.refs.form).stopLoading();
        this.setState({
          cardErrorMessage: response.error.message,
          witchCardError: this.state.paymentSelect,
          isDisabled: false,
        });
      }
    });
  }

  toggleNewCard(e) {
    e.preventDefault();

    this.setState({
      openNewCard: !this.state.openNewCard
    });
  }

  renderNewCard() {
    if (!this.state.openNewCard) return null ;

    let card = ["","","","","","","",""];
    if (SpaceMarket.Config.Env == "development") {
      card = ["4242","4242","4242","4242","Dummy","06","2020","111"];
    }

    let yearOptions = [];
    const thisYear = (new Date()).getFullYear();
    for (let year = thisYear; year < thisYear + 20; year++) {
      yearOptions.push(
        <option key={year} value={year}>{year}</option>
      );
    }

    let monthOptions = [];
    for (let month = 1; month <= 12; month++) {
      monthOptions.push(
        <option key={month} value={sprintf("%02d", month)}>{month}</option>
      );
    }
    let newCardStyle = {};
    if (this.state.activeCards) {
      newCardStyle = {display: "none"};
    }

    let errorMessage = null;
    if (this.state.cardErrorMessage) {
      errorMessage = <p className="popup-form__required request-payment__required"><i className="fa fa-exclamation-circle"></i>{this.state.cardErrorMessage}</p>;
    }

    return(
      <div>
        {errorMessage}
        <dl className="request-payment__cards-detail popup-form__dl">
          <dt>カード番号</dt>
          <dd>
            <input type="text" name="card[no_1]" defaultValue={card[0]} id="js-card_no_1" maxLength="4" autoComplete="off" className="js-card-item__remove request-payment__cards-num" />
            <input type="text" name="card[no_2]" defaultValue={card[1]} id="js-card_no_2" maxLength="4" autoComplete="off" className="js-card-item__remove request-payment__cards-num" />
            <input type="text" name="card[no_3]" defaultValue={card[2]} id="js-card_no_3" maxLength="4" autoComplete="off" className="js-card-item__remove request-payment__cards-num" />
            <input type="text" name="card[no_4]" defaultValue={card[3]} id="js-card_no_4" maxLength="4" autoComplete="off" className="js-card-item__remove request-payment__cards-num" />
            <i className="fa fa-cc-visa fa-lg payment-card__visa ml5"></i><i className="fa fa-cc-mastercard fa-lg payment-card__master ml5"></i><i className="fa fa-cc-amex fa-lg payment-card__amex ml5"></i>
          </dd>
          <dt>名義人</dt>
          <dd>
            <p className="request-payment__cards-notes">クレジットカード表記のまま入力してください。半角英数。</p>
            <input type="text" name="card[name]" defaultValue={card[4]} id="js-card_name" autoComplete="off" placeholder="Taro Space" className="js-card-item__remove request-payment__cards-name" /></dd>
          <dt>有効期限</dt>
          <dd className="clearfix">
            <div className="request-payment__select-bg">
              <span className="service-select">
                <select name="card[exp_m]" id="js-card_exp_m" defaultValue={card[5]} className="js-card-item__remove service-select__purpose w70">
                  {monthOptions}
                </select>
              </span>
            </div>
            <span className="request-payment__cards-ym">月</span>
            <div className="request-payment__select-bg">
              <span className="service-select">
                <select name="card[exp_y]" id="js-card_exp_y" defaultValue={card[6]} className="js-card-item__remove service-select__purpose w110">
                  {yearOptions}
                </select>
              </span>
            </div>
            <span className="request-payment__cards-ym">年</span>
          </dd>
          <dt>セキュリティコード</dt>
          <dd>
            <p className="request-payment__cards-notes">裏面右端の3桁もしくは表面右端の4桁の数字を入力してください。</p>
            <input className="js-card-item__remove w70" type="text" name="card[cvc]" defaultValue={card[7]} id="js-card_cvc" maxLength="4" autoComplete="off"  />
          </dd>
          <dt></dt>
          <dd>
            <input onClick={this.didClickAddNewCard.bind(this)} type="button" className="button-blue w100 pt9 pb9" value="追加" />
          </dd>
        </dl>
      </div>
    );
  }

  paymentDidSelect(e) {
    const value = parseInt(e.currentTarget.value);
    let paymentId = null;
    let companyId = null;
    if (e.currentTarget.getAttribute('data-paymentId')) {
      paymentId = parseInt(e.currentTarget.getAttribute('data-paymentId'));
    }
    if (e.currentTarget.getAttribute('data-companyId')) {
      companyId = parseInt(e.currentTarget.getAttribute('data-companyId'));
    }
    this._setPayment(value, paymentId, companyId);
    this.billingRecalc();
  }

  _setPayment(value, paymentId, companyId) {
    this.setState({paymentSelect: value});
    switch (value) {
      case SMConst.PaymentSelect.Card:
        this.requestParams.destination_type = SMConst.BillingDestinationType.User;
        this.requestParams.payment_method = SMConst.PaymentMethod.Card;
        this.requestParams.payment_id = paymentId;
        this.setState({selectedCard: paymentId});
        break;
      case SMConst.PaymentSelect.Postpay:
        this.requestParams.destination_type = SMConst.BillingDestinationType.User;
        this.requestParams.payment_method = SMConst.PaymentMethod.Postpay;
        break;
      case SMConst.PaymentSelect.BusinessAccount:
        this.requestParams.destination_type = SMConst.BillingDestinationType.Company;
        this.requestParams.company_id = companyId;
        this.requestParams.payment_method = "";
        this.setState({selectedCompany: companyId});
        break;
      case SMConst.PaymentSelect.Bank:
        this.requestParams.payment_method = SMConst.PaymentMethod.Bank;
        break;
    }
  }

  billingRecalc() {
    SMRoomResource.validateReservation(this.props.room.id, this.requestParams, (reservation, error, xhr) => {
      if (error) {
        this.setState({reservation: this.props.reservation});
      } else {
        this.setState({reservation: reservation});
      }
    });
  }

  renderFormItemError(name) {
    const message = this.state.errors[name];
    if (message) {
      return(
        <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }

  renderSelectBox(room, eventType, useType, capacity) {
    let selectBoxes = [];
    selectBoxes.push(
      <div key="event-type" className="col-sm-12 col-md-4">
        <h2 className="popup-form__title">
          <span className="icon-form icon-form__required">必須</span>
          <span className="popup-form__title-text">目的</span>
        </h2>
        <div className="request-select__area">
          <span className="service-select">
            <select defaultValue={eventType} onChange={this.eventTypeDidChange.bind(this)} name="event_type" className="service-select__purpose">
              {this.renderEventTypeOptions(room)}
            </select>
          </span>
          {this.renderFormItemError("event_type")}
        </div>
      </div>
    );
    selectBoxes.push(
      <div key="use-type" className="col-sm-12 col-md-4">
        <h2 className="popup-form__title">
          <span className="icon-form icon-form__required">必須</span>
          <span className="popup-form__title-text">区分</span>
        </h2>
        <div className="request-select__area">
          <span className="service-select">
            <select defaultValue={useType} onChange={this.useTypeDidChange.bind(this)} name="use_type" className="service-select__purpose">
              {this.renderUseTypeOptions(room)}
            </select>
          </span>
          {this.renderFormItemError("use_type")}
        </div>
      </div>
    );
    selectBoxes.push(
      <div key="capacity" className="col-sm-12 col-md-4">
        <h2 className="popup-form__title">
          <span className="icon-form icon-form__required">必須</span>
          <span className="popup-form__title-text">人数(~{room.capacity}人)</span>
        </h2>
        <div className="request-select__area">
          <div className="request-select__area-number">
            {this.renderCapacitySelect()}
          </div>
        </div>
      </div>
    );

    if (this.isStayPlan()) {
      selectBoxes.shift();
      selectBoxes.pop();
    } else {
      if (this.isPerPersonPlan()) {
        selectBoxes.pop();
      }
    }

    return(
      <div className="odd-col__line clearfix">
        {selectBoxes}
      </div>
    );
  }

  renderBusinessDescription() {
    if (!SMPaymentSelectHelper.isBusinessAccount(this.state.paymentSelect)) return false;
    const companyId = this.state.selectedCompany;
    const company = this.state.companies.find((company) => {
      return company.id == companyId;
    });

    return(
      <div className="odd-col__line clearfix">
        <div className="col-xs-12">
          <h2 className="popup-form__title">
           <span className="icon-form icon-form__required">必須</span>
           <span className="popup-form__title-text">{company.name}への説明</span>
          </h2>
          <p className="popup-form__text">{company.name}にこの予約について説明しましょう。どんなイベント・会議で利用するのかなどを伝えることで、支払い業務がスムーズになります。</p>
          <textarea value={this.state.businessUseDescription}
           className="popup-form__textarea request-contact__textarea"
           placeholder="12/20の会社設立10周年記念イベントの会場に使いたいと考えています。プロジェクターや全社員300人分の椅子もそろっています。よろしくお願いします。"
           onChange={this.businessUseDescriptionDidChange.bind(this)} />
          {this.renderFormItemError("business_use_description")}
        </div>
      </div>
    );
  }

  renderContentForm(room) {
    if (this.props.inquiry) return null;
    return(
      <div className="odd-col__line clearfix">
        <div className="col-xs-12">
          <h2 className="popup-form__title">
            <span className="icon-form icon-form__optional">任意</span>
            <span className="popup-form__title-text">利用用途の詳細</span>
          </h2>
          <p className="popup-form__text">ホストにどのような用途で利用するのかを伝えましょう。できる限り詳細に伝えることで、予約リクエストの承認率がアップします。</p>
          <textarea onChange={this.contentDidChange.bind(this)} name="content" className="popup-form__textarea request-contact__textarea" placeholder="高校の友人が久しぶりに集まるパーティーを開きたいと思っています。大人10人、子供3名の計13名です。キッチンを利用し簡単な料理をふるまったりと、アットホームな会にしたいと思っています。よろしくお願いします。"></textarea>
          {this.renderFormItemError("content")}
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.isOpen) return null;
    const room = this.props.room;
    const buttonClassName = `button-blue request-submit ${(this.state.isDisabled) ? "button-disabled" : ''}`;
    const cancelPolicyUrl = SMAppHelper.policyUrl(room);
    const termsUrl = SMAppHelper.termsUrl(room);
    const canPayCard = room.owner.enable_card;
    const cardSelectStyle = canPayCard ? {} : {display: "none"};
    const inquiry = this.props.inquiry;
    const eventType = inquiry ? inquiry.event_type : null;
    const useType = inquiry ? inquiry.use_type : null;
    const capacity = inquiry ? inquiry.capacity : null;
    const newCardStyle = this.state.openNewCard ? "fa fa-chevron-down mr5" : "fa fa-chevron-right mr5";
    const plan = this.props.reservation.plan ? this.props.reservation.plan : this.props.reservation.room;
    const directPlan = plan.direct_reservation_accepted ? <p className="request-notice__title is-required"><i className="fa fa-flash fa-lg icon-direct mr5"></i>このプランは即時に予約が完了します。</p> : null;
    const bankSelectStyle = this.state.isCardOnly || plan.direct_reservation_accepted || !SMAppHelper.isSpacemarketEmployee(this.props.currentUser) ? {display: "none"} : {};
    const postpaySelectStyle = this.state.isCardOnly && canPayCard ? {display: "none"} : {};
    const businessAccountSelectStyle = this.state.isCardOnly && this.state.companies.length > 0 ? {display: "none"} : {};

    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
    			<div className="md-content">
            <div className="page__popup">
              <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
                <div className="page__popup-col1">
                  <p className="page__popup__cancel search-change__cancel"><a className="md-close" onClick={this.dismiss.bind(this)} href="#"><span className="page__popup__cancel-icon search-change__cancel-icon">×</span><span>キャンセル</span></a></p>
                  <div className="popup-headline">
                    <h2 className="popup-headline__title">予約リクエスト</h2>
                    <p className="popup-headline__text">予約リクエストに必要な情報を入力して、「この内容で送信する」ボタンを押してください。</p>
                  </div>
                  <div className="row">
                    {this.renderSelectBox(room, eventType, useType, capacity)}
                    {this.renderContentForm()}
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">支払い方法の選択</span>
                        </h2>
                        <p className="popup-form__text">ホストが予約リクエストを承認すると、指定されたお支払い方法で決済されます（お支払いはリクエストが承認されるまで行われません）。詳しくは <a href={Routes.payment_flow_about_index_path()} target="_blank" className="a__underline">決済の流れ</a> をご覧ください。</p>
                        <div className="request-payment">
                          <div style={cardSelectStyle} className="request-payment__choose">
                            <div className="request-payment__choose-title clearfix">
                              <span className="request-payment__name">クレジットカード</span>
                            </div>
                            <div className="request-payment__cards-box">
                              {this.renderActiveCards()}
                              <p className="request-payment__cards-registered">
                                <a onClick={this.toggleNewCard.bind(this)} href="#" className="a__underline"><i className={newCardStyle}></i>新しいカードを追加</a>
                              </p>
                              {this.renderNewCard()}
                            </div>
                          </div>
                          <div style={postpaySelectStyle} className="request-payment__choose">
                            <input type="radio"
                              onClick={this.paymentDidSelect.bind(this)}
                              checked={SMPaymentSelectHelper.isPostpay(this.state.paymentSelect)}
                              value={SMConst.PaymentSelect.Postpay}
                              id="request-radio__04"
                              name="payment_select" />
                            <label htmlFor="request-radio__04" className="service-radio">
                              <span className="request-payment__name">銀行振込(後払い)<span className="request-payment__name-notes">請求書による後払いです。別途後払い手数料がかかります。</span></span>
                            </label>
                          </div>
                          <div style={bankSelectStyle} className="request-payment__choose">
                            <input type="radio"
                                   onClick={this.paymentDidSelect.bind(this)}
                                   checked={SMPaymentSelectHelper.isBank(this.state.paymentSelect)}
                                   value={SMConst.PaymentSelect.Bank}
                                   id="request-radio__05"
                                   name="payment_select" />
                            <label htmlFor="request-radio__05" className="service-radio">
                              <span className="request-payment__name">銀行振込(旧)<span className="request-payment__name-notes">社内利用限定</span></span>
                            </label>
                          </div>
                          {this.state.companies.map((company) => {
                            return(
                              <div style={businessAccountSelectStyle} className="request-payment__choose">
                                <input type="radio"
                                  id={`request-radio__05_${company.id}`}
                                  onClick={this.paymentDidSelect.bind(this)}
                                  name="company_id"
                                  value={SMConst.PaymentSelect.BusinessAccount}
                                  data-companyId={company.id}
                                  checked={SMPaymentSelectHelper.isBusinessAccount(this.state.paymentSelect) && this.state.selectedCompany == company.id} />
                                <label htmlFor={`request-radio__05_${company.id}`} className="service-radio">
                                  <span className="request-payment__name">{company.name}に請求</span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                        {this.renderFormItemError("payment_method")}
                      </div>
                    </div>
                    {this.renderBusinessDescription()}
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">ポイント/クーポンの利用</span>
                        </h2>
                        <div className="popup-form__radio">
                          <input type="radio" value={0} id="point-coupon-radio-01" name="point-coupon-radio" checked={this.state.selectedDiscount == 0} onClick={this.discountDidChangeValue.bind(this)} disabled={this.state.isAppliedCoupon} />
                          <label htmlFor="point-coupon-radio-01" className="service-radio"><span className="request-payment__name">ポイント</span></label>
                          <input type="radio" value={1} id="point-coupon-radio-02" name="point-coupon-radio" checked={this.state.selectedDiscount == 1} onClick={this.discountDidChangeValue.bind(this)} disabled={this.state.isAppliedPoint} />
                          <label htmlFor="point-coupon-radio-02" className="service-radio"><span className="request-payment__name">クーポン</span></label>
                          <p className="popup-form__radio-required">ポイントとクーポンの併用はできません</p>
                        </div>
                        {this.renderDiscountForm()}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="page__popup-col1__breakdown">
                  <div className="page__popup-col1">
                    <div className="row">
                      <div className="clearfix">
                        <div className="col-xs-12">
                          <h2 className="request-breakdown__title">スペースご利用料金 内訳</h2>
                          {SMRenderHelper.renderBillingTable(this.state.reservation, {className: "popup-form__dl request-breakdown__detail"})}
                        </div>
                      </div>
                      <div className="clearfix mb20">
                        <div className="col-xs-12 col-md-7">
                          <div className="request-notice">
                          {directPlan}
                          <p className="request-notice__title">ホストの承認後、予約成立となります。</p>
                            <ul className="request-notice__list">
                              <li>※<a href={termsUrl} target="_blank" className="a__underline">ゲスト規約</a>をお読みください。</li>
                              <li>※送信後、内容の確認等ホストとのやりとりが開始されます。</li>
                              <li>※予約成立後のキャンセルには<a href={cancelPolicyUrl} target="_blank" className="a__underline">キャンセルポリシー</a>が適用されます。</li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xs-12 col-md-5">
                          {this.renderRequestError('schedules')}
                          <input ref="submitButton" type="submit" name="commit" value="この内容で送信する" className={buttonClassName} disabled={this.state.isDisabled} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
    		</div>
        <div className="md-overlay"></div>
      </div>
    );
  }

}

export default SMReservationRequestView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationRequestView.jsx